export default "__VITE_ASSET__DhST7lJ___"